export const scenariosData = [
  {
    id: 0,
    name: "Scenario 1",
    description: "This is the first scenario.",
    sliders: [
      {
        id: "mist",
        label: "Mist",
        type: "range",
        value: 0,
        min: 0,
        max: 1
      },
      {
        id: "heat",
        label: "Bottom Heat",
        type: "range",
        value: 0,
        min: 0,
        max: 1
      },
      {
        id: "light",
        label: "Light",
        type: "range",
        value: 0,
        min: 0,
        max: 1
      }
    ],
    stages: [
      {
        name: "Stage 1 of Scenario 1",
        id: "mist",
        description:
          "URC arrive, and are freshly stuck and placed in the mist chamber. Please adjust the slider, and press Apply to produce a change.",
        correctFeedback:
          "Correct!  Intermittent mist should be high right as you are introducing fresh material to the propagation tent.  Newly processed material does not have any root tissue, so is unable to replace any water lost through transpiration.  Increasing mist frequency at this stage will help slow transpiration by raising relative humidity, thereby reducing the amount of water lost.",
        incorrectFeedback:
          "Not ideal.  Increase rate of intermittent mist at this stage to increase relative humidity around the cutting.  An increase in relative humidity will decrease the rate of water loss through transpiration, which is ideal at this stage as the cutting does not have any root tissue to replenish water stores with.",
        correctAnswer: 1,
        incorrectAnswer: 0,
        correctAnswerCriteria: (answer) => answer >= 0.75
      },
      {
        name: "Stage 2 of Scenario 1",
        id: "heat",
        description:
          "In the following activity you will be changing the percentage of Heat and see the changes these variables have on the growth of a Geranium plant.",
        correctFeedback:
          "Correct!  Supplying bottom heat at this stage will speed the rate of dedifferentiation, leading to faster build up of callus and eventually root initials.",
        incorrectFeedback:
          "Not ideal - for many species, supplying bottom heat is necessary to kickstart the dedifferentiation process, which yields callus.",
        correctAnswer: 1,
        incorrectAnswer: 0,
        correctAnswerCriteria: (answer) => answer >= 0.5
      },
      {
        name: "Stage 3 of scenario 1",
        id: "light",
        description:
          "In the following activity you will be changing the percentage of Light and see the changes these variables have on the growth of a Geranium plant.",
        correctFeedback:
          "Correct!  Lowering light at this stage, perhaps by applying shade cloth the propagation area, will help reduce the rate of transpiration.",
        incorrectFeedback:
          "Not ideal.  Light at close to ambient conditions in the greenhouse (full sun) is going to drive up transpiration rate.  Remember, at this stage, our cuttings don’t have roots and thus don’t have a way to replace water lost through transpiration.  Lower ambient light levels to help lower the rate of water loss.",
        correctAnswer: 0,
        incorrectAnswer: 1,
        correctAnswerCriteria: (answer) => answer <= 0.5
      },
      {
        name: "Summary",
        description:
          "A new cutting will need lots of assistance at first, as we need to prevent water loss while the cutting does not have roots to replace water lost.  Mist should be high at this stage to raise relative humidity and prevent water loss.  Bottom heat should be relatively high to encourage root formation.  Light should be reduced from normal production levels to reduce rate of transpiration."
      }
    ],
    altTags: [
      {
        id: "root",
        altTag:
          "Geranium cutting in soil. No visible roots, and three healthy leaves."
      },
      {
        id: "root0",
        altTag:
          "Geranium cutting in soil. No visible roots. Two healthy leaves, and one dead leaf. "
      },
      {
        id: "root1",
        altTag:
          "Geranium cutting in soil. No visible roots. Visible mist. Four healthy leaves."
      },
      {
        id: "root10",
        altTag:
          "Geranium cutting in soil. No visible roots. Four healthy leaves."
      },
      {
        id: "root11",
        altTag:
          "Geranium cutting in soil. No visible roots. Visible callus. Four healthy leaves. Heating pad underneath."
      },
      {
        id: "root110",
        altTag:
          "Geranium cutting in soil. No visible roots. Visible callus. Four healthy leaves."
      },
      {
        id: "root111",
        altTag:
          "Geranium cutting in soil. No visible roots. Visible callus. Three healthy leaves. One dead leaf. Excessive overhead light.  "
      }
    ]
  },
  {
    id: 1,
    name: "Scenario 2",
    description: "This is the second scenario.",
    sliders: [
      {
        id: "mist",
        label: "Mist",
        type: "range",
        value: 0,
        min: 0,
        max: 1
      },
      {
        id: "heat",
        label: "Bottom Heat",
        type: "range",
        value: 0,
        min: 0,
        max: 1
      },
      {
        id: "light",
        label: "Light",
        type: "range",
        value: 0,
        min: 0,
        max: 1
      }
    ],
    stages: [
      {
        name: "Stage 1 of Scenario 2",
        id: "mist",
        description: "URC are developing callus and root initials.",
        correctFeedback:
          "Correct!  At this point we still need to continue thinking about reducing rate of transpiration but can probably start reducing mist levels as a first defense against disease.",
        incorrectFeedback:
          "Not ideal - Since the cutting is just barely starting to form roots, we still need to worry about reducing the rate of transpiration at this stage.  Keeping humidity via intermittent mist high will help support the cutting.",
        correctAnswer: 1,
        incorrectAnswer: 0,
        correctAnswerCriteria: (answer) => answer >= 0.5
      },
      {
        name: "Stage 2 of Scenario 2",
        id: "heat",
        description: "URC are developing callus and root initials.",
        correctFeedback:
          "Correct!  We still need to keep bottom heat relatively high as callus and roots continue to develop.",
        incorrectFeedback:
          "Not ideal, as we still need heat applied to the bottom of our cuttings to stimulate root development.  At this stage, the heat is helping stimulate redifferentiation of cells into root initials.",
        correctAnswer: 1,
        incorrectAnswer: 0,
        correctAnswerCriteria: (answer) => answer >= 0.5
      },
      {
        name: "Stage 3 of Scenario 2",
        id: "light",
        description: "URC are developing callus and root initials.",
        correctFeedback:
          "Correct! Light should remain somewhat reduced at this stage from full glasshouse levels, but it’s okay to start increasing light levels as roots form.",
        incorrectFeedbackLowerRange:
          "Not ideal. Light should remain somewhat reduced at this stage from full glasshouse levels, but it’s okay to start increasing light levels as roots form.",
        incorrectFeedbackHigherRange:
          "Not yet! Light levels should still remain relatively lower than normal at this point to help reduce the rate of transpiration.",
        correctAnswer: 0,
        incorrectAnswer: 1,
        incorrectFeedbackLowerRangeCriteria: (answer) => answer < 0.5,
        incorrectFeedbackHigherRangeCriteria: (answer) => answer > 0.8,
        correctAnswerCriteria: (answer) => answer >= 0.5 && answer <= 0.8
      },
      {
        name: "Summary",
        description:
          "As callus and root initials begin to develop, your cutting will require slightly less support as it will be acclimated to the mist bench environment.  At this stage, it is alright for the mist to remain high, but you might consider slowly reducing it to help reduce the prevalence of fungal disease that like high relative humidity.  Bottom heat should still be on to encourage root development.  Light should be kept moderate as the cutting is still very fragile but could be raised a little bit over what you would provide a brand new cutting."
      }
    ],
    altTags: [
      {
        id: "root",
        altTag:
          "Geranium cutting in soil. No visible roots. Visible callus. Four healthy leaves."
      },
      {
        id: "root0",
        altTag:
          "Geranium cutting in soil. No visible roots. Visible callus. Three healthy leaves. One dead leaf."
      },
      {
        id: "root1",
        altTag:
          "Geranium cutting in soil. No visible roots. Visible callus. Visible mist. Five healthy leaves."
      },
      {
        id: "root10",
        altTag:
          "Geranium cutting in soil. No visible roots. Visible callus. Five healthy leaves."
      },
      {
        id: "root11",
        altTag:
          "Geranium cutting in soil. No visible roots. Visible callus. Five healthy leaves. Heating pad underneath."
      },
      {
        id: "root101",
        altTag:
          "Geranium cutting in soil. Visible root initials. Visible callus. Five healthy leaves. Low overhead light."
      },
      {
        id: "root110",
        altTag:
          "Geranium cutting in soil. Visible root initials. Visible callus. Five healthy leaves. Medium overhead light."
      },
      {
        id: "root111",
        altTag:
          "Geranium cutting in soil. Visible root initials. Visible callus. Five healthy leaves. High overhead light."
      }
    ]
  },
  {
    id: 2,
    name: "Scenario 3",
    description: "This is the third scenario.",
    sliders: [
      {
        id: "mist",
        label: "Mist",
        type: "range",
        value: 0,
        min: 0,
        max: 1
      },
      {
        id: "heat",
        label: "Bottom Heat",
        type: "range",
        value: 0,
        min: 0,
        max: 1
      },
      {
        id: "light",
        label: "Light",
        type: "range",
        value: 0,
        min: 0,
        max: 1
      }
    ],
    stages: [
      {
        name: "Stage 1 of Scenario 3",
        id: "mist",
        description:
          "A heatwave hits your propagation environment!  How will you help combat the effects of heat?",
        correctFeedback:
          "Correct! Increasing, or maintaining high levels of intermittent mist will help reduce the rate of transpiration.  A higher degree of mist may even help to cool the propagation environment through evaporation (evaporative cooling).",
        incorrectFeedback:
          "Not ideal - Recall that heat will drive up the rate of transpiration, so we should be doing what we can to mitigate that.  We can drive down transpiration by raising relative humidity.",
        correctAnswer: 1,
        incorrectAnswer: 0,
        correctAnswerCriteria: (answer) => answer >= 0.75
      },
      {
        name: "Stage 2 of Scenario 3",
        id: "heat",
        description:
          "A heatwave hits your propagation environment!  How will you help combat the effects of heat?",
        correctFeedback:
          "Correct!  Bottom heat is probably already being supplied by the extra heat you’re getting in the greenhouse.  If you’re working with a bottom heat system that is adaptive, or involves a temperature probe, bottom heat is probably already turned off at this point.",
        incorrectFeedback:
          "Not needed for today.  Many systems for delivering bottom heat will actually turn themselves off above a programmed heat threshold.",
        correctAnswer: 0,
        incorrectAnswer: 1,
        correctAnswerCriteria: (answer) => answer < 0.5
      },
      {
        name: "Stage 3 of Scenario 3",
        id: "light",
        description:
          "A heatwave hits your propagation environment!  How will you help combat the effects of heat?",
        correctFeedback:
          "Correct! Applying shade cloth or even an extra layer of shadecloth over the propagation environment will help plants ride out the heatwave. Reducing light will help drive down the rate of transpiration, as well as help to cool the environment.",
        incorrectFeedback:
          "Not ideal - continue supplying shade through the heatwave to help drive down rates of transpiration. Shade is also a first step in cooling the propagation environment.",
        correctAnswer: 0,
        incorrectAnswer: 1,
        correctAnswerCriteria: (answer) => answer <= 0.75
      },
      {
        name: "Summary",
        description:
          "During a heatwave, the extra heat will drive up the rate of transpiration. You’ll want to do all you can to combat that. You might increase the mist levels to raise relative humidity and provide evaporative cooling. Bottom heat is likely to be superfluous at this stage, and generally bottom heat controls have a temperature cutoff that will turn bottom heat off over a temperature threshold. To further reduce transpiration and attempt to cool the environment, you might add a layer of shade cloth over your propagation house, thereby decreasing light even more."
      }
    ],
    altTags: [
      {
        id: "root",
        altTag:
          "Geranium cutting in soil. Visible root initials. Visible callus. Five healthy leaves."
      },
      {
        id: "root0",
        altTag:
          "Geranium cutting in soil. Visible root initials. Visible callus. Four healthy leaves. One dead leaf."
      },
      {
        id: "root1",
        altTag:
          "Geranium cutting in soil. Visible root initials. Visible callus. Visible mist. Five healthy leaves. "
      },
      {
        id: "root10",
        altTag:
          "Geranium cutting in soil. Substantial root growth. Visible callus. Five healthy leaves. "
      },
      {
        id: "root11",
        altTag:
          "Geranium cutting in soil. Visible root initials. Visible callus. Visible mist. Five healthy leaves. Heating pad underneath."
      },
      {
        id: "root100",
        altTag:
          "Geranium cutting in soil. Substantial root growth. Visible callus. Five healthy leaves. "
      },
      {
        id: "root101",
        altTag:
          "Geranium cutting in soil. Substantial root growth. Visible callus. Five healthy leaves. Excessive overhead light."
      }
    ]
  },
  {
    id: 3,
    name: "Scenario 4",
    description: "Root initials begin expanding into the media.",
    sliders: [
      {
        id: "mist",
        label: "Mist",
        type: "range",
        value: 0,
        min: 0,
        max: 1
      },
      {
        id: "heat",
        label: "Bottom Heat",
        type: "range",
        value: 0,
        min: 0,
        max: 1
      },
      {
        id: "light",
        label: "Light",
        type: "range",
        value: 0,
        min: 0,
        max: 1
      }
    ],
    stages: [
      {
        name: "Stage 1 of Scenario 4",
        id: "mist",
        description: "Root initials begin expanding into the media.",
        correctFeedback:
          "Correct! As the roots expand into the media, the cutting is able to pull water from the media. Reducing transpiration is less of an issue now that cuttings can begin replenishing water lost. This is the point at which we need to start acclimating our cuttings to life off the mist bench.",
        incorrectFeedback:
          "Not ideal. At this point, our cuttings have roots that are expanding into the media, which means they are able to replenish water lost through transpiration. Keeping cuttings on high mist at this stage only increases the chances of fungal disease.",
        correctAnswer: 0,
        incorrectAnswer: 1,
        correctAnswerCriteria: (answer) => answer <= 0.5
      },
      {
        name: "Stage 2 of Scenario 4",
        id: "heat",
        description: "Root initials begin expanding into the media.",
        correctFeedback:
          "Correct! At this point, development is at an end and we need to encourage growth. Bottom heat may inhibit root growth.",
        incorrectFeedback:
          "Not ideal. At this point, development is at an end and we need to encourage growth. Bottom heat may inhibit root growth.",
        correctAnswer: 0,
        incorrectAnswer: 1,
        correctAnswerCriteria: (answer) => answer <= 0.5
      },
      {
        name: "Stage 3 of Scenario 4",
        id: "light",
        description: "Root initials begin expanding into the media.",
        correctFeedback:
          "Correct! Again, as roots are elongating into the soil, we know that combatting or slowing transpiration is less of an issue because the plant is able to replenish waterloss. We also need to start acclimating plants to the higher light levels they will experience in the greenhouse.",
        incorrectFeedback:
          "Not ideal. Now that we are done with root development and root growth is occurring, there is less need to reduce light.",
        correctAnswer: 1,
        incorrectAnswer: 0,
        correctAnswerCriteria: (answer) => answer >= 0.5
      },
      {
        name: "Summary",
        description:
          "As root development increases, mist can be reduced. Cuttings are capable of drawing some moisture from the media at this point. Mist should be reduced as soon as possible to help prevent disease. Bottom heat can be reduced or turned off at this point, to allow root elongation. You should also begin increasing light levels to acclimate cuttings to general greenhouse conditions."
      }
    ],
    altTags: [
      {
        id: "root",
        altTag:
          "Geranium cutting in soil. Substantial root growth. Visible callus. Five healthy leaves."
      },
      {
        id: "root0",
        altTag:
          "Geranium cutting in soil. Substantial root growth. Visible callus. Six healthy leaves."
      },
      {
        id: "root1",
        altTag:
          "Geranium cutting in soil. Substantial root growth. Visible callus. Visible mist. Four healthy leaves. One dead leaf."
      },
      {
        id: "root00",
        altTag:
          "Geranium cutting in soil. Full root growth. Visible callus. Six healthy leaves."
      },
      {
        id: "root01",
        altTag:
          "Geranium cutting in soil. Substantial root growth. Visible callus. Six healthy leaves."
      },
      {
        id: "root000",
        altTag:
          "Geranium cutting in soil. Full root growth. Visible callus. Six healthy leaves."
      },
      {
        id: "root001",
        altTag:
          "Geranium cutting in soil. Full root growth. Visible callus. Six healthy leaves. Light overhead."
      }
    ]
  },
  {
    id: 4,
    name: "Scenario 5",
    description: "This is the fifth scenario.",
    sliders: [
      {
        id: "mist",
        label: "Mist",
        type: "range",
        value: 0,
        min: 0,
        max: 1
      },
      {
        id: "heat",
        label: "Bottom Heat",
        type: "range",
        value: 0,
        min: 0,
        max: 1
      },
      {
        id: "light",
        label: "Light",
        type: "range",
        value: 0,
        min: 0,
        max: 1
      }
    ],
    stages: [
      {
        name: "Stage 1 of Scenario 5",
        id: "mist",
        description: "Roots have reached the edge of each cell.",
        correctFeedback:
          "Correct! Now that the cutting is fully rooted, there is no reason for mist. Move the cutting off the mist as soon as possible to prevent disease.",
        incorrectFeedback:
          "It’s not a great idea to leave cuttings on the mist bench any longer than is necessary, as the propagation environment cant also encourage growth of fungal disease particularly. At this stage, since the cutting is fully rooted, it would be best to leave the mist off.",
        correctAnswer: 0,
        incorrectAnswer: 1,
        correctAnswerCriteria: (answer) => Number(answer) === 0
      },
      {
        name: "Stage 2 of Scenario 5",
        id: "heat",
        description: "Roots have reached the edge of each cell.",
        correctFeedback:
          "Correct! Just like in the last stage, we are past the development of roots and on to growing roots. Bottom heat at this stage serves no purpose.",
        incorrectFeedback:
          "Not ideal. Just like in the last stage, we are past the development of roots and on to the growing stage. Bottom heat may actually inhibit root elongation into the media.",
        correctAnswer: 0,
        incorrectAnswer: 1,
        correctAnswerCriteria: (answer) => Number(answer) === 0
      },
      {
        name: "Stage 2 of Scenario 5",
        id: "light",
        description: "Roots have reached the edge of each cell.",
        correctFeedback:
          "Correct! Our cutting is rooted and capable of sustaining regular amounts of transpiration. Since we worked on acclimating the cutting to regular greenhouse conditions last stage, we can now move the cutting to higher levels of irradiance.",
        incorrectFeedback:
          "Not ideal. The cutting is fully finished and capable of handling higher levels of irradiance. Not supplying higher light levels at this point could stunt growth.",
        correctAnswer: 1,
        incorrectAnswer: 0,
        correctAnswerCriteria: (answer) => answer >= 0.75
      },
      {
        name: "Summary",
        description:
          "The flower blooms. You have successfully propagated the cutting."
      }
    ],
    altTags: [
      {
        id: "root",
        altTag:
          "Geranium cutting in soil. Full root growth. Visible callus. Seven healthy leaves."
      },
      {
        id: "root0",
        altTag:
          "Geranium cutting in soil. Full root growth. Visible callus. Seven healthy leaves."
      },
      {
        id: "root1",
        altTag:
          "Geranium cutting in soil. Full root growth. Visible callus. Seven healthy leaves. Visible mist."
      },
      {
        id: "root00",
        altTag:
          "Geranium cutting in soil. Full root growth. Visible callus. Seven healthy leaves."
      },
      {
        id: "root01",
        altTag:
          "Geranium cutting in soil. Full root growth. Visible callus. Seven healthy leaves. Heating pad underneath."
      },
      {
        id: "root000",
        altTag:
          "Geranium cutting in soil. Full root growth. Visible callus. Seven healthy leaves."
      },
      {
        id: "root001",
        altTag:
          "Geranium cutting in soil. Full root growth. Visible callus. Seven healthy leaves. Bloom visible."
      }
    ]
  },
  {
    id: "intro",
    instructions: "When you are ready to begin, press Start."
  }
];
